import React from 'react';
import '../Footer/Footer.css';

function Footer(){
  return(
    <div className="tim main-footer">
      <footer>
        <div className="row">
<div className="col-12"><p className="tim text-center">Colusa City Hall: <a className="tim footer-text" href="https://www.google.com/maps/dir//425+Webster+St,+Colusa,+CA+95932/@39.2090092,-122.0113867,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x8083676e7b4f187d:0x83b8e96635cd98f2!2m2!1d-122.009198!2d39.2090051" target="_blank" rel="noreferrer">425 Webster St. Colusa, Ca 95932</a> | <a className="tim" href="tel:5304584941">(530) 458-4941</a> | <a className="tim" href="mailto:cbic@cityofcolusa.com">cbic@cityofcolusa.com</a></p></div>
        </div>
<div className="tim footer-text text-center"><p className="mb-0">Copyright © 2020-2021 Discover Colusa |<a className="tim" href="https://timgangl.com/" target="_blank" rel="noreferrer"> Tim Gangl Web Development</a></p></div>
      </footer>
    </div>
  )
}

export default Footer;